import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from "react-redux";
import styled from "@emotion/styled";
import Cookies from 'js-cookie';
import { Col, Row, Divider, message, Select, Tabs } from "antd";
import VocalSelection, { VocalType } from "../components/VocalSelection";
import { VcGenerateParam, VcGetVoices } from "../service/AIapi";
import VoiceService, { VcApiPath } from '../service/VoiceService';
import { SoundRecognizer } from "../components/SoundRecognizer";

import AudioRecorder from '../components/AudioRecorder/AudioRecorder';
import { AudioPlaybackBar } from '../components/AudioPlaybackBar';
import MySlider, { range } from '../components/Slider/Slider';
import Login from "../components/Login/Login";
import TabbedContent from '../components/Tabs';
import Describe from '../components/Describe/Describe';
import { SoundConversionDescribeData } from '../components/staticDescribeData';
import MyDragger from "../components/Dragger/Dragger"
import SensitiveDataConsent from '../components/SensitiveDataConsent';

import './style.scss'

// 播放器一共有5个状态
//
// 1. 未播放
// 2. 播放中
// 3. 暂停了
// 4. 继续播放
// 5. 播完了重播

// 下面的按钮有：
// 1. 立即合成
// 2. 合成中
// 3. 停止播放
// 4. 继续播放
// 5. 重播


const PlayerStatus = {
    start: '立即转换',
    done: '已转换',
    running: '转换中',
    stop: '停止播放',
    resume: '继续播放',
    replay: '重播',
}

const SoundConversion = (): React.ReactElement => {
    const [isLogin, setIsLogin] = useState(!!Cookies.get('access_token'));
    const login = useSelector((state: any) => state?.guard?.isLogin);
    const minorMode = useSelector((state: any) => state?.guard?.minorMode);
    const [select, setSelected] = useState(0)
    const [currentObject, setCurrenyObject] = useState<any>()
    const [loading, setLoading] = useState<boolean>(false)
    const [btnText, setBtnText] = useState<string>(PlayerStatus.start)

    const [typeList, setTypeList] = useState<Array<VocalType>>([])
    const [filterVoiceGender, setFilterVoiceGender] = useState('All');
    const [recordingType, setRecordingType] = useState('noFlowType')
    const [activeKey, setActiveKey] = useState('');
    const [fileBase64Audio, setFileBase64Audio] = useState('');
    const [recordBase64Audio, setRecordBase64Audio] = useState('');
    const [audioSrc, setAudioSrc] = useState('');
    const [prohibitPlay, setProhibitPlay] = useState(true)
    const [sensitiveConsent, setSensitiveConsent] = useState(false)
    const sensitiveConsentRef = useRef(false)
    const generateAbortRef = useRef<AbortController | null>(null)
    const streamingSessionRef = useRef(0)
    const streamingAudioContextRef = useRef<AudioContext | null>(null)
    const streamingPlaybackTimeRef = useRef(0)
    const streamingPlaybackQueueRef = useRef<Promise<void>>(Promise.resolve())
    // const [volume, setVolume] = useState<number>(50);
    // const [speed, setSpeed] = useState<number>(0)
    const W3CWebSocket = require('websocket').w3cwebsocket;
    const [audioBlob, setAudioBlob] = useState<any>([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await fetch('static/vc_voices_vaas.json');
                const jsonData = await response.json();
                let temp: Array<VocalType> = [];

                jsonData.forEach((item: any, index: number) => {
                    temp.push({
                        nickname: item.nickname,
                        voice_id: item.voice_id,
                        voice_type: item.voice_type,
                        gender: item.gender,
                        avatar_url: item.avatar_url,
                        default_text: item.default_text
                    }
                    )
                })
                setTypeList(temp);

            } catch (error) { }
        };
        fetchData()
        setIsLogin(!!Cookies.get('access_token'))
    }, [])
    useEffect(() => {
        setIsLogin(!!Cookies.get('access_token'))
    }, [login])


    const changeVocal = (index: number, vocal: any) => {
        if (recordingType !== 'flowType') {
            console.log(vocal, 'vocal')
            setCurrenyObject(vocal)
            setSelected(index);
            setLoading(false);
            setBtnText(PlayerStatus.start);
        }

    }
    const GenerateAudio = () => {
        if (!sensitiveConsentRef.current) {
            message.warning('请先阅读并同意语音文件敏感个人信息处理提示')
            return
        }
        generateAbortRef.current?.abort()
        const controller = new AbortController()
        generateAbortRef.current = controller
        const speechParam: VcGenerateParam = {
            voice: typeList[select].voice_id,
            rate: Number(48000),  // 输出，仅 48000
            encoding: 'wav',  // 输出，仅 wav
            source_encoding: 'wav' // 仅 wav
        }

        VoiceService.post(`${VcApiPath}/generate`, { payload: speechParam, data: activeKey === 'file' ? fileBase64Audio : recordBase64Audio },
            { responseType: 'blob', signal: controller.signal })
            .then(res => {
                if (!sensitiveConsentRef.current) {
                    return
                }
                setLoading(false);
                let blob = new Blob([res.data], { type: 'audio/wav' })
                setAudioSrc(URL.createObjectURL(blob));
                setBtnText(PlayerStatus.done);
                setProhibitPlay(false)
            })
            .catch(error => {
                if (error?.code === 'ERR_CANCELED') {
                    return
                }
                if (error.response && error.response.status === 500) {
                    const reader = new FileReader();
                    reader.onload = function () {
                        console.log(this.result);
                        alert(`服务端错误（请保留错误信息，反馈给相关技术支持人员）:\n${this.result}`);
                    };
                    reader.readAsText(error.response.data);
                } else if (error.response && error.response.status === 400) {
                    const reader = new FileReader();
                    reader.onload = function () {
                        alert(`客户端错误（请根据以下错误信息，修改输入内容）:\n${this.result}`);
                    };
                    reader.readAsText(error.response.data);
                } else if (error.message === "Request failed with status code 504"
                    || error.message === "Request failed with status code 502") {
                    alert('服务异常：请参考使用说明书进行排查')
                }
                else {
                    alert('未知错误: ' + error.message);
                }
                setLoading(false);
                setBtnText(PlayerStatus.start);
            })
    }

    const GenerateSpeech = () => {
        if (!sensitiveConsentRef.current) {
            message.warning('请先阅读并同意语音文件敏感个人信息处理提示')
            return
        }
        switch (btnText) {
            case PlayerStatus.stop:
                setBtnText(PlayerStatus.resume);
                break;
            case PlayerStatus.start:
                GenerateAudio();
                setLoading(true);
                setBtnText(PlayerStatus.running);
                break;
            case PlayerStatus.resume:
                setBtnText(PlayerStatus.stop);
                break;
            case PlayerStatus.replay:
                setBtnText(PlayerStatus.stop);
                break;
            default:
                break;
        }
    }

    const HandleSelectChange = async (value: string) => {
        setFilterVoiceGender(value);
        const filteredList = typeList.filter(item => value === 'All' || item.gender === value);
        const selectDataIndex = filteredList.findIndex(it => it === currentObject);
        setSelected(selectDataIndex > -1 ? selectDataIndex : 0);
    };

    const HandleAudioRecorded = (base64Data: string) => {
        if (!sensitiveConsentRef.current) {
            setRecordBase64Audio('')
            return
        }
        setRecordBase64Audio(base64Data);
        setBtnText(PlayerStatus.start);
    }

    const isEmptySourceAudio = () => {
        if (!isLogin || !sensitiveConsent) {
            return true
        }
        if (activeKey === 'file') {
            return !fileBase64Audio
        } else {
            return !recordBase64Audio
        }
    }

    const colCount = 3;

    const HandleFileChange = () => {
        setBtnText(PlayerStatus.start);
    };
    // 切换tab
    const handleChangeTab = (e: React.SetStateAction<string>) => {
        setActiveKey(e)
        if (e !== 'flowType') {
            setRecordingType('noFlowType')
            streamingAudioContextRef.current?.close()
            streamingAudioContextRef.current = null
        } else {
            setSelected(0)
            setCurrenyObject({
                nickname: "晓凌",
                voice_id: "xiaoling",
                voice_type: "甜美女声",
                gender: "Female",
                avatar_url: "https://mt-vaas-web.tos-cn-beijing.volces.com/vc/vaas_web_demo/sweet_female.png"
            })
            setRecordingType('flowType')
        }
    }
    let result = ''
    let asrWS = null
    const clientRef = useRef(null)
    const token = Cookies.get('access_token')
    const socketProtocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
    const socketUrl = `${socketProtocol}//${window.location.host}/vc/api/v1/streaming_vc?token=${token}`
    const openWebSocket = (sessionId: number) => {
        if ("WebSocket" in window) {
            asrWS = new W3CWebSocket(socketUrl)
            const socket = asrWS
            clientRef.current = socket
            socket.onopen = function () {
                if (!sensitiveConsentRef.current || sessionId !== streamingSessionRef.current) {
                    socket.close()
                    return
                }
                socket.send(JSON.stringify({
                    "type": "StartConversion",
                    "payload": {
                        "voice": "xiaoling",
                        "input_info": {
                            "sample_rate": 16000,
                            "channels": 1,
                            "bits": 16,
                            "audio_encoding": "pcm"
                        },
                        "output_info": {
                            "sample_rate": 48000,
                            "channels": 1,
                            "bits": 16,
                            "audio_encoding": "pcm"
                        }
                    }
                }))
            }
            socket.onmessage = function (_msg) { parseResult(_msg.data, sessionId) }
            socket.onclose = function (error) {
                console.log("WebSocket 连接断开", error)
                if (clientRef.current === socket) {
                    clientRef.current = null
                }
                if (result.length > 0) {
                    result = ""
                }
            }
            socket.onerror = function (error) { console.log("WebSocket 连接失败", error) }
        }
    }

    const playStreamingPcm = (pcmBlob: Blob, sessionId: number) => {
        streamingPlaybackQueueRef.current = streamingPlaybackQueueRef.current.then(async () => {
            const audioContext = streamingAudioContextRef.current
            if (!audioContext || sessionId !== streamingSessionRef.current) {
                return
            }

            const pcmBuffer = await pcmBlob.arrayBuffer()
            if (!pcmBuffer.byteLength || sessionId !== streamingSessionRef.current) {
                return
            }

            const sampleCount = Math.floor(pcmBuffer.byteLength / 2)
            const audioBuffer = audioContext.createBuffer(1, sampleCount, 48000)
            const channelData = audioBuffer.getChannelData(0)
            const pcmView = new DataView(pcmBuffer)
            for (let index = 0; index < sampleCount; index++) {
                channelData[index] = pcmView.getInt16(index * 2, true) / 32768
            }

            const source = audioContext.createBufferSource()
            source.buffer = audioBuffer
            source.connect(audioContext.destination)
            const startTime = Math.max(audioContext.currentTime, streamingPlaybackTimeRef.current)
            source.start(startTime)
            streamingPlaybackTimeRef.current = startTime + audioBuffer.duration
        }).catch(error => {
            console.error('流式音频播放失败', error)
        })
    }

    function parseResult(data: any, sessionId: number) {
        if (!sensitiveConsentRef.current || sessionId !== streamingSessionRef.current) {
            return
        }
        if (data instanceof Blob) {
            playStreamingPcm(data, sessionId)
            setAudioBlob((prevBlobs: any) => {
                const updatedBlobs = [...prevBlobs, data];
                return updatedBlobs;
            })
        }

        if (typeof data === 'string') {
            const res = JSON.parse(data)
            if (res?.type === 'ConversionStarted') {
                console.log('录制声音开始返回')
            }
            if (res?.type === 'ConversionCompleted') {
                // 返回完成
                setProhibitPlay(false)
            }
        }
    }
    useEffect(() => {
        if (audioBlob?.length > 0) {
            createWavFile(audioBlob)
        }
    }, [audioBlob])

    const createWavFile = (audioBlob) => {
        if (!sensitiveConsentRef.current) {
            return
        }
        const totalLength = audioBlob?.reduce((sum: any, blob: { size: any; }) => sum + blob.size, 0);
        const concatenatedBlob = new Blob(audioBlob, { type: 'audio/wav' });
        const header = createWavHeader(totalLength);
        const wavBlob = new Blob([header, concatenatedBlob], { type: 'audio/wav' });
        const url = URL.createObjectURL(wavBlob)
        setAudioSrc(url)
    }

    function TransferUpload(sessionId, number, blobOrNull, duration, blobRec, isClose) {
        if (blobOrNull) {
            var blob = blobOrNull
            var encTime = blob.encTime
            var reader = new FileReader()
            reader.onloadend = function () {
                if (!sensitiveConsentRef.current || sessionId !== streamingSessionRef.current || asrWS?.readyState !== 1) {
                    return
                }
                asrWS.send(reader.result)
            }
            reader.readAsArrayBuffer(blob)
        }
    }
    // 开始录音
    const startRecording = () => {
        if (!sensitiveConsentRef.current) {
            message.warning('请先阅读并同意语音文件敏感个人信息处理提示')
            return
        }
        const sessionId = streamingSessionRef.current + 1
        streamingSessionRef.current = sessionId
        streamingAudioContextRef.current?.close()
        const AudioContextConstructor = window.AudioContext || (window as any).webkitAudioContext
        const audioContext = new AudioContextConstructor()
        streamingAudioContextRef.current = audioContext
        streamingPlaybackTimeRef.current = audioContext.currentTime
        streamingPlaybackQueueRef.current = Promise.resolve()
        void audioContext.resume()
        setProhibitPlay(true)
        setAudioSrc('')
        setAudioBlob([])
        SoundRecognizer.init({
            soundType: 'pcm',
            sampleRate: 16000,
            translerCallBack: (number, blobOrNull, duration, blobRec, isClose) =>
                TransferUpload(sessionId, number, blobOrNull, duration, blobRec, isClose)
        })
        openWebSocket(sessionId)
    }

    const stopRecording = () => {
        if (!sensitiveConsentRef.current) {
            if (clientRef.current) {
                clientRef.current.close()
                clientRef.current = null
            }
            SoundRecognizer.recordCancel()
            return
        }
        const client = clientRef.current
        if (client?.readyState === 1) {
            client.send(JSON.stringify({
                "type": "StopConversion"
            }))
        }
        SoundRecognizer.recordClose()
    }

    const handleSensitiveConsentChange = (checked: boolean) => {
        sensitiveConsentRef.current = checked
        setSensitiveConsent(checked)
        if (checked) {
            return
        }

        generateAbortRef.current?.abort()
        generateAbortRef.current = null
        streamingSessionRef.current += 1
        streamingAudioContextRef.current?.close()
        streamingAudioContextRef.current = null
        if (clientRef.current) {
            clientRef.current.close()
            clientRef.current = null
        }
        SoundRecognizer.recordCancel()
        setFileBase64Audio('')
        setRecordBase64Audio('')
        setAudioBlob([])
        setAudioSrc('')
        setLoading(false)
        setProhibitPlay(true)
        setBtnText(PlayerStatus.start)
    }


    function createWavHeader(length, sampleRate = 48000, numChannels = 1, bitsPerSample = 16) {
        const byteRate = sampleRate * numChannels * bitsPerSample / 8;
        const blockAlign = numChannels * bitsPerSample / 8;

        const buffer = new ArrayBuffer(44);
        const view = new DataView(buffer);

        function writeString(view, offset, string) {
            for (let i = 0; i < string.length; i++) {
                view.setUint8(offset + i, string.charCodeAt(i));
            }
        }

        writeString(view, 0, 'RIFF'); // ChunkID
        view.setUint32(4, 36 + length, true); // ChunkSize
        writeString(view, 8, 'WAVE'); // Format
        writeString(view, 12, 'fmt '); // Subchunk1ID
        view.setUint32(16, 16, true); // Subchunk1Size
        view.setUint16(20, 1, true); // AudioFormat (PCM)
        view.setUint16(22, numChannels, true); // NumChannels
        view.setUint32(24, sampleRate, true); // SampleRate
        view.setUint32(28, byteRate, true); // ByteRate
        view.setUint16(32, blockAlign, true); // BlockAlign
        view.setUint16(34, bitsPerSample, true); // BitsPerSample
        writeString(view, 36, 'data'); // Subchunk2ID
        view.setUint32(40, length, true); // Subchunk2Size

        return buffer;
    }
    return (
        <>
            <DescribeDiv>
                {SoundConversionDescribeData?.map((item, index) => {
                    return < Describe data={item} index={index} />
                })}
            </DescribeDiv>
            <SoundFrame>
                <Container>
                    <SoundContainer>
                        <SoundTitle>选择转换音色</SoundTitle>
                        <Select
                            defaultValue="All"
                            variant={"borderless"}
                            style={{ marginRight: "4px", float: "right", color: '#666666', fontSize: 12, marginTop: '-5px' }}
                            onChange={HandleSelectChange}
                            disabled={recordingType === 'flowType'}
                            options={[
                                { value: 'All', label: '全部' },
                                { value: 'Female', label: '女声' },
                                { value: 'Male', label: '男声' },
                            ]}
                        />
                        <SoundCardContainer className='sound-card-container'>
                            <TypeListDiv>
                                <Row gutter={[15, 0]}>
                                    {typeList.filter(item => filterVoiceGender === 'All' || item.gender === filterVoiceGender).map((item, i) =>
                                        <Col style={{ marginBottom: 20, }} key={i.toString()} span={24 / colCount}>
                                            <VocalSelection key={`type-${i}`} vocal={item} index={i} isSelected={i === select} click={changeVocal} disabled={recordingType === 'flowType'} />
                                        </Col>,
                                    )}
                                </Row>
                            </TypeListDiv>
                        </SoundCardContainer>
                    </SoundContainer>
                    <SourceAudioContainer>
                        <SoundTitle style={{ marginTop: 20, marginBottom: 12, }}>音色转换方式</SoundTitle>
                        <SensitiveDataConsent checked={sensitiveConsent} onChange={handleSensitiveConsentChange} description="为使用音色转换功能处理我录制或上传的语音文件" />
                        <TabbedContent onChange={handleChangeTab} tabs={
                            [
                                {
                                    name: 'record', label: "语音录制", content: <> <div style={{ height: 406, background: '#F6F6F6' }}>
                                        <AudioRecorder disabled={!isLogin || minorMode || !sensitiveConsent} onAudioRecorded={HandleAudioRecorded} />
                                    </div></>
                                },
                                {
                                    name: 'file', label: "文件上传", content: <> <div style={{ height: 406, background: '#F6F6F6' }}>
                                        <MyDragger disabled={!isLogin || minorMode || !sensitiveConsent} base64Audio={fileBase64Audio} setBase64Audio={setFileBase64Audio} fileChangeHook={HandleFileChange} />
                                    </div></>
                                },
                                {
                                    name: 'flowType', label: "流式转换", content: <><div style={{ height: 406, background: '#F6F6F6' }}>
                                        <AudioRecorder disabled={!isLogin || minorMode || !sensitiveConsent} tab={'asr'} start={startRecording} stopRecord={stopRecording} onAudioRecorded={HandleAudioRecorded} />
                                    </div></>
                                }
                            ]

                        } />
                    </SourceAudioContainer>
                </Container>
                {AudioPlaybackBar(isEmptySourceAudio, loading, GenerateSpeech, btnText, audioSrc, recordingType, prohibitPlay)}
            </SoundFrame >
            <Login></Login>
        </>
    );
}

export default SoundConversion;

const DescribeDiv = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    margin-top: 60px;  
    height: 198px;
`

const ConfigDiv = styled.div`
  display: flex;
  /* flex-direction: column;
  justify-content: space-between; */
  align-items: center;
  margin-top: 20px;

`
const VolumeDiv = styled.div`
  width: 100%;
  height: 100px;
//   margin-top: 12px;
`
const SoundContainer = styled.div`
flex: 1;
`

const SoundCardContainer = styled.div`
  min-height: 90%;
  max-height: 90%;
  overflow-x: clip !important;
`

const SourceAudioContainer = styled.div`
  width: 442px;
  padding:0 0px 20px 20px;
`

const Container = styled.div`
  display: flex;
  grid-template-columns: 1fr 1fr;
  /* grid-gap: 10px; */
`

const SoundFrame = styled.div`
  width: 100%;
  box-sizing: border-box;
  /* height: 550px; */
  background: #FFFFFF;
  box-shadow: 0 30px 40px 0 rgba(0, 0, 0, 0.06);
  border-radius: 6px;
//   margin-top: 60px;
  padding: 20px;
  display: flex;
  flex-direction: column;
`

const SoundTitle = styled.span`
  font-size: 16px;
  color: #222222;
  line-height: 16px;
  font-weight: 600;

`

const TypeListDiv = styled.div`
//   display: flex;
//   flex-direction: row;
//   justify-content: left;
  margin-top: 12px;
`
